import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ResolvedUrl } from '@wearejh/m2-pwa-engine/lib/utils/resolve';

import { navigationComplete } from './events';
import { NavigationCompleteData } from './types';
import { useNavigationComplete } from './useNavigationComplete';

type NavigationListenerProps = {
    serverResolvedUrl?: ResolvedUrl;
};

/**
 * Monitors for navigation completion events (client & server routing).
 */
export function NavigationListener(props: NavigationListenerProps) {
    const dispatch = useDispatch();

    const handleNavigationComplete = useCallback(
        (data: NavigationCompleteData) => {
            dispatch(navigationComplete(data));
        },
        [dispatch],
    );

    useNavigationComplete({
        onComplete: handleNavigationComplete,
        serverResolvedUrl: props.serverResolvedUrl,
    });

    return null;
}

export default NavigationListener;
